export const LargerScreens = "1441px"
export const LG = "1199px";
export const SM = "992px";
export const XS = "767px";
export const CustomDesktop = "1366px";

export const GOOGLE_MAPS_API_KEY = "AIzaSyC3t4IIWGxiSpBGgRBmydfOqvmUmQlr9oI";